import { render, staticRenderFns } from "./DBOuseLandNormalizedChart.vue?vue&type=template&id=00ea8aef&scoped=true"
import script from "./DBOuseLandNormalizedChart.vue?vue&type=script&lang=js"
export * from "./DBOuseLandNormalizedChart.vue?vue&type=script&lang=js"
import style0 from "./DBOuseLandNormalizedChart.vue?vue&type=style&index=0&id=00ea8aef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ea8aef",
  null
  
)

export default component.exports